import React, {ReactElement} from 'react';
import {toString} from 'ui/keyboard';
import {useKeyboard} from 'store/UserInput';

import {DynamicFontSize} from 'components/DynamicFontSize';
import {Center} from 'components/Center';
import {Shout} from 'components/Text';
import {Wrapper} from './style';

export const DisplayValue = (): ReactElement => {
  const keyboard = useKeyboard();
  const display = toString(keyboard);
  const color = display === '0' ? 'grey' : 'default';

  return (
    <Wrapper>
      <Center>
        <Shout color={color} thin>
          <DynamicFontSize>{display}</DynamicFontSize>
        </Shout>
      </Center>
    </Wrapper>
  );
};
